import React from 'react';
import PropTypes from 'prop-types';

import SumContainer from '~/components/exposures/ExposuresTable/SumContainer';
import toCents from '~/Utils/toCents';

const SubPercentageSum = ({ exposure, value }) => {
  const coinsurancePercentage = exposure?.coverage?.coinsurance_insurer_percentage;
  if (!coinsurancePercentage) return null;

  // COINSURANCE_ROUNDING: Round to 2 decimals after coinsurance calculation to prevent precision issues
  // Division by coinsurance percentage can create infinite repeating decimals (e.g., 100 / 0.33 = 303.030303...)
  const calculatedValue = toCents(value / (0.01 * coinsurancePercentage));
  if (calculatedValue === undefined || calculatedValue === null) return <>-</>;

  return (
    <span className="text-sm text-grey-700">
      <SumContainer sum={calculatedValue} fontWeight={300} />
    </span>
  );
};

SubPercentageSum.propTypes = {
  exposure: PropTypes.object.isRequired,
  value: PropTypes.number.isRequired,
};

export default SubPercentageSum;
